var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 69,
    viewBox: "0 0 146 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stripe_Logo,_revised_2016 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.154 35.1665C129.154 27.2276 125.285 20.9634 117.892 20.9634C110.467 20.9634 105.975 27.2276 105.975 35.1045C105.975 44.4389 111.278 49.1526 118.89 49.1526C122.603 49.1526 125.41 48.3153 127.532 47.1369V40.9346C125.41 41.989 122.977 42.6402 119.888 42.6402C116.862 42.6402 114.179 41.5859 113.836 37.9265H129.091C129.091 37.5234 129.154 35.9108 129.154 35.1665ZM113.743 32.2205C113.743 28.7162 115.895 27.2587 117.861 27.2587C119.764 27.2587 121.791 28.7162 121.791 32.2205H113.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9329 20.9634C90.8756 20.9634 88.9103 22.3899 87.8184 23.3823L87.4128 21.4596H80.5496V57.6187L88.3487 55.9751L88.3799 47.1989C89.503 48.0052 91.1564 49.1526 93.9017 49.1526C99.4859 49.1526 104.571 44.687 104.571 34.8564C104.54 25.8632 99.3923 20.9634 93.9329 20.9634ZM92.0611 42.3301C90.2205 42.3301 89.1286 41.6789 88.3799 40.8726L88.3487 29.3674C89.1598 28.4681 90.2829 27.8479 92.0611 27.8479C94.9 27.8479 96.8654 31.011 96.8654 35.0735C96.8654 39.229 94.9312 42.3301 92.0611 42.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8179 19.134L77.6483 17.4593V11.1641L69.8179 12.8077V19.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M77.6483 21.4907H69.8179V48.6256H77.6483V21.4907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4261 23.7858L60.9269 21.491H54.1885V48.6258H61.9876V30.2361C63.8282 27.8483 66.9479 28.2824 67.915 28.6235V21.491C66.9167 21.1188 63.2667 20.4366 61.4261 23.7858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8278 14.7612L38.2158 16.3738L38.1846 41.2138C38.1846 45.8035 41.6474 49.1837 46.2645 49.1837C48.8226 49.1837 50.6944 48.7185 51.7239 48.1603V41.8651C50.7256 42.2682 45.7966 43.6947 45.7966 39.1051V28.0961H51.7239V21.4907H45.7966L45.8278 14.7612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7389 29.3674C24.7389 28.158 25.7372 27.6928 27.3906 27.6928C29.7615 27.6928 32.7564 28.4061 35.1273 29.6775V22.3899C32.538 21.3665 29.9799 20.9634 27.3906 20.9634C21.0577 20.9634 16.8462 24.2506 16.8462 29.7396C16.8462 38.2987 28.7009 36.9342 28.7009 40.6245C28.7009 42.051 27.453 42.5162 25.706 42.5162C23.1167 42.5162 19.8098 41.4618 17.1893 40.0353V47.416C20.0906 48.6564 23.0231 49.1836 25.706 49.1836C32.1949 49.1836 36.656 45.9894 36.656 40.4384C36.6248 31.1971 24.7389 32.8407 24.7389 29.3674Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.2a7f157015f893cd427f11a1ce8756d7.svg";
export { ForwardRef as ReactComponent };